<template>
    <div>
        test1报表
    </div>
</template>

<script>
    export default {
        name: "test1"
    }
</script>

<style scoped>

</style>